import { isReadingPanePositionRight } from '../selectors/readingPanePosition';
import { shouldShowReadingPane } from '../selectors/shouldShowReadingPane';
import { isReadingPaneEmpty } from '../selectors/isReadingPaneEmpty';
import {
    isCopilotChatDrawerShown,
    isEmptyReadingPaneFillDisabled,
} from 'owa-copilot-chat-drawer-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Whether BizChat should occupy the empty reading pane area. Used at drawer-open time
 * (synchronously, in the satchel orchestrator) and reactively (via useSideEffect in
 * MailView). Distinct from `shouldDockBizChatInReadingPane`, which gates the immersive-
 * search dock and includes a `!isAlreadyDocked` check; this one is a pure predicate.
 */
export function shouldDockBizChatInEmptyReadingPane(targetWindow: Window): boolean {
    return (
        targetWindow === window &&
        isGlobalFeatureEnabled('mon-copilot-bizchat-drawer-empty-rp-fill') &&
        isCopilotChatDrawerShown(targetWindow) &&
        !isEmptyReadingPaneFillDisabled(targetWindow) &&
        isReadingPanePositionRight() &&
        shouldShowReadingPane() &&
        isReadingPaneEmpty()
    );
}
